import { render, staticRenderFns } from "./FileAttachment.vue?vue&type=template&id=05511383&scoped=true"
import script from "./FileAttachment.vue?vue&type=script&lang=ts"
export * from "./FileAttachment.vue?vue&type=script&lang=ts"
import style0 from "./FileAttachment.vue?vue&type=style&index=0&id=05511383&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05511383",
  null
  
)

export default component.exports